import React, { useState } from "react";
import PageShell from "../dashboard/PageShell";
import ProjectFormActions from "../../components/forms/ProjectForm/ProjectFormActions";

interface AddNewMemberProps {}

interface MemberFormData {
  fullName: string;
  email: string;
  mobilePhone: string;
  otherPhone: string;
  password: string;
  confirmPassword: string;
}

const AddNewMember: React.FC<AddNewMemberProps> = () => {
  const [formData, setFormData] = useState<MemberFormData>({
    fullName: "",
    email: "",
    mobilePhone: "",
    otherPhone: "",
    password: "",
    confirmPassword: "",
  });

  const handleInputChange = (field: keyof MemberFormData, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    console.log("Saving member:", formData);
  };

  return (
    <PageShell title="Thêm mới Thành viên">
      <div className="space-y-6">
        {/* Header */}
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-800">
            Thêm mới Thành viên
          </h1>
        </div>

        {/* Form Container */}
        <div className="bg-white rounded-lg p-4">
          <div className="space-y-6">
            {/* Row 1: Họ tên - Địa chỉ email */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Họ tên <span className="text-red-500">(*)</span>
                </label>
                <input
                  type="text"
                  value={formData.fullName}
                  onChange={(e) =>
                    handleInputChange("fullName", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập họ tên..."
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Địa chỉ email <span className="text-red-500">(*)</span>
                </label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => handleInputChange("email", e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập địa chỉ email..."
                />
              </div>
            </div>

            {/* Row 2: Điện thoại di động - Điện thoại khác */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Điện thoại di động <span className="text-red-500">(*)</span>
                </label>
                <input
                  type="text"
                  value={formData.mobilePhone}
                  onChange={(e) =>
                    handleInputChange("mobilePhone", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập điện thoại di động..."
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Điện thoại khác
                </label>
                <input
                  type="text"
                  value={formData.otherPhone}
                  onChange={(e) =>
                    handleInputChange("otherPhone", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập điện thoại khác..."
                />
              </div>
            </div>

            {/* Row 3: Mật khẩu - Nhắc lại mật khẩu */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Mật khẩu <span className="text-red-500">(*)</span>
                </label>
                <input
                  type="password"
                  value={formData.password}
                  onChange={(e) =>
                    handleInputChange("password", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập mật khẩu..."
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nhắc lại mật khẩu <span className="text-red-500">(*)</span>
                </label>
                <input
                  type="password"
                  value={formData.confirmPassword}
                  onChange={(e) =>
                    handleInputChange("confirmPassword", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập lại mật khẩu..."
                />
              </div>
            </div>
          </div>
        </div>

        <ProjectFormActions
          onSave={handleSave}
          onCancel={() => window.history.back()}
        />
      </div>
    </PageShell>
  );
};

export default AddNewMember;
